// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from '../node_modules/axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import $ from 'jquery'
// import Swiper from 'vue-awesome-swiper';
// import 'swiper/dist/css/swiper.min.css';

Vue.prototype.$axios = axios
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default global options } */)
// Vue.use(Swiper),

axios.defaults.baseURL = "http://xinghuo.yxguizhou.com/"
// axios.defaults.headers.post['Content-Type'] = "application/x-www-form-urlencoded"


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    axios,
    components: {App},
    template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js